import React, { FC, useEffect, useState } from 'react';
import ProfileImage from '../profile-image/profile-image';
import numberGreyIcon from '../../images/Number Grey.svg';
import emailGreyIcon from '../../images/Email Grey.svg';
import idNumberGreyIcon from '../../images/ID Number Grey.svg';
import { useFormikContext } from 'formik';
import { CategoryFieldGroup } from '../../models/CategoryFieldGroup';
import './user-card.css'
import { CustomFieldBuilder } from '../../containers/utilities/CustomFieldBuilder';
import { useLocale } from '../../contexts/localeContext';
import UserDetailsCard from './user-details-card';

interface UserCardProps {
    supportedFields: CategoryFieldGroup[]
}

const UserCard: FC<UserCardProps> = ({ supportedFields }) => {
    const formik = useFormikContext<any>();
    const [primary, setPrimary] = useState(1)
    const { translate } = useLocale();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);

    useEffect(() => {
        if (formik.values.email === null) {
            formik.setFieldValue('email', '');
        }

        if (formik.values.pin === null) {
            formik.setFieldValue('pin', '');
        }
    }, [formik.values.email, formik.values.pin])

    return (
        <div className="w-full p-2 inline-flex justify-start items-center bg-whited">
            <div className={`${!formik.values.id && 'blocked'}`}><ProfileImage
                handleSubmit={formik.handleSubmit}
                primary={primary}
                onSetPrimary={(i) => setPrimary(i)} /></div>
            <div className="flex flex-col py-4 px-4 card-details">
                <UserDetailsCard/>
            </div>
            {supportedFields
                .filter((fieldGroup) => fieldGroup.fields?.length > 0)
                .map((fieldGroup, index) => {
                    return <>
                        {fieldGroup.fields
                            .reduce((formFields, field) => customFieldBuilder.buildCardField(formFields, field), new Array(0))
                            .map(fieldBundle =>
                                <div className="flex flex-col py-4 px-8">{fieldBundle.map(field => field.content)}</div>
                            )}
                    </>
                })}
        </div>
    );
}

export default UserCard;
